import { render, staticRenderFns } from "./IcoXSquare.vue?vue&type=template&id=cac5aaf0"
import script from "./IcoXSquare.vue?vue&type=script&lang=js"
export * from "./IcoXSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports